/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import ProfileContent from 'apps/ProfileContent'
import Button from 'elements/Button'
import * as styles from './NewPlanAccepted.scss'

const cx = classNames.bind(styles)

interface IProps {
  t: Text,
  onConfirm: () => void
}

const NewPlanAccepted: React.SFC<IProps> = ({ t, onConfirm }) => (
  <ProfileContent>
    <div className={cx('row', styles.topSpace80)}>
      <div className='col-md-12'>
        <div className={styles.title}>
          <h2>{t('accepted')}</h2>
        </div>
      </div>
    </div>
    <div className='row'>
      <div className={cx('col-md-12', 'text-center')}>
        <div className={styles.congratulations}>
          <p>{t('checkEmail')}</p>
        </div>
      </div>
    </div>
    <div className={cx('row', styles.topSpace50)}>
      <div className={cx('col-md-12', 'text-center')}>
        <div className={cx(styles.nextButton)}>
          <Button onClick={onConfirm}>
            {t('ok')}
          </Button>
        </div>
      </div>
    </div>
  </ProfileContent>
)

export default NewPlanAccepted
